import * as React from "react";
import {
    Image,
    tokens,
    makeStyles,
    TeachingPopover,
    TeachingPopoverTrigger,
    Button,
    TeachingPopoverSurface,
    TeachingPopoverHeader,
    TeachingPopoverCarousel,
    TeachingPopoverCarouselCard, TeachingPopoverTitle,
    TeachingPopoverBody, TeachingPopoverCarouselFooter, TeachingPopoverCarouselPageCount
} from "@fluentui/react-components";
import {DocumentModel, ZDocumentType} from "../../utils/models/document.model";
import {useEffect} from "react";

export interface HeaderProps {
    title: string;
    logo: string;
    document: DocumentModel;
}

const useStyles = makeStyles({
    welcome__header: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        flexShrink: 0,
        textAlign: "center",
        paddingTop: "16px",
        paddingBottom: "12px",
        paddingLeft: "12px",
        paddingRight: "12px",
        backgroundColor: tokens.colorNeutralBackground3,
        overflowWrap: "anywhere",
    },
    subtitle: {
        width: "100%",
        maxWidth: "100%",
        marginTop: "8px",
        marginBottom: 0,
        textAlign: "center",
        overflowWrap: "anywhere",
    },
    title: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightRegular,
        fontColor: tokens.colorNeutralBackgroundStatic,
        width: "100%",
        maxWidth: "100%",
        overflowWrap: "anywhere",
    },
    docName: {
        width: "100%",
        maxWidth: "100%",
        marginTop: "4px",
        marginBottom: "4px",
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightMedium,
        fontColor: tokens.colorNeutralBackgroundStatic,
        textAlign: "center",
        overflowWrap: "anywhere",
    },
});

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
    const {title, logo, document} = props;
    const styles = useStyles();

    function displayType(type: ZDocumentType): string {
        switch (type) {
            case ZDocumentType.MODELE_FACTURE:
                return "le modèle de facture :";
            case ZDocumentType.MODELE_RELANCE:
                return "le modèle de relance :";
            case ZDocumentType.MODELE_DOCUMENT:
                return "le modèle de document :";
            default:
                return null;
        }
    }

    const [estConnecte, setEstConnecte] = React.useState(false);
    useEffect(() => {
        setEstConnecte(!!localStorage.getItem("zLawyerToken"));
    }, []);

    const displayText = displayType(document?.Type);
    return (
        <section className={styles.welcome__header}>
            {estConnecte && <Image width="40" height="40" src={logo} alt={title}/>}
            {!estConnecte && <TeachingPopover defaultOpen={true} appearance="brand">
                <TeachingPopoverTrigger>
                    <Image width="40" height="40" src={logo} alt={title}/>
                </TeachingPopoverTrigger>
                <TeachingPopoverSurface style={{ maxWidth: "min(360px, calc(100vw - 24px))", boxSizing: "border-box" }}>
                    <TeachingPopoverHeader>Bienvenue sur le complément zLawyer pour Word</TeachingPopoverHeader>
                    <TeachingPopoverCarousel defaultValue="1">
                        <TeachingPopoverCarouselCard value="1">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>Intégrer du contenu avec Zéphyr</TeachingPopoverTitle>
                                <div>
                                    Depuis le prompt, vous pouvez demander à Zéphyr de rédiger un contenu spécifique.
                                    Le texte généré s’insère automatiquement à l’endroit où se trouve le curseur.
                                </div>
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>

                        <TeachingPopoverCarouselCard value="2">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>Insérer un champ de fusion du dossier</TeachingPopoverTitle>
                                <div>
                                    En sélectionnant le dossier, puis la rubrique correspondante, vous pouvez insérer
                                    directement une donnée du dossier dans le document Word.
                                </div>
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>

                        <TeachingPopoverCarouselCard value="3">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>Corriger une sélection de texte</TeachingPopoverTitle>
                                <div>
                                    Il suffit de sélectionner une partie du texte dans le document Word et de cliquer
                                    sur
                                    “Corriger le texte sélectionné”. En cliquant ensuite sur “Insérer le texte corrigé”,
                                    le
                                    complément remplacera automatiquement le texte par la version corrigée.
                                </div>
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>

                        <TeachingPopoverCarouselFooter
                            next="Suivant"
                            previous="Précédent"
                            initialStepText="Fermer"
                            finalStepText="Commencer">
                            <TeachingPopoverCarouselPageCount>
                                {(currentIndex: number, totalPages: number) => `${currentIndex} sur ${totalPages}`}
                            </TeachingPopoverCarouselPageCount>
                        </TeachingPopoverCarouselFooter>
                    </TeachingPopoverCarousel>
                </TeachingPopoverSurface>
            </TeachingPopover>}
            {displayText && <div className={styles.subtitle}>
                Vous éditez {displayText}
                {document?.NomDossier && <div className={styles.title}>Dossier : {document?.NomDossier}</div>}
            </div>}
            <h2 className={styles.docName}>{document?.Nom}</h2>
        </section>
    );
};

export default Header;
